import { EventEngineEventsService } from '@amzn/event-engine-events-sdk';
import {
    differenceInMilliseconds,
    formatDuration,
    intervalToDuration,
} from 'date-fns';

import roundDate from './round-date';

const getEventDuration = (
    { endTime }: EventEngineEventsService.ParticipantGetEventResponse,
    intervalMS = 1
) => {
    const now = new Date();

    if (differenceInMilliseconds(endTime, now) <= 0) {
        return '';
    }

    const duration = intervalToDuration({
        start: roundDate(now, intervalMS),
        end: roundDate(endTime, intervalMS),
    });

    return formatDuration(duration);
};

export default getEventDuration;
